var React      = require('react');
var QuizOption = require('./quiz_option');

var QuizOptions = React.createClass({
  propTypes: {
    answers: React.PropTypes.array.isRequired,
    onChange: React.PropTypes.func.isRequired,
    selectedAnswer: React.PropTypes.string,
    correctAnswers: React.PropTypes.array.isRequired,
    id: React.PropTypes.string.isRequired
  },

  getDefaultProps: function() {
    return {
      selectedAnswer: null
    };
  },

  render: function() {
    return (
      <ul className="c-answers-list">
        {this.props.answers.map(this._renderOption)}
      </ul>
    );
  },

  _renderOption: function (answer, index) {
    return (
      <li key={index} className="c-answers-list-item">
        <QuizOption
          answer={answer}
          isSelected={this._isChecked(answer)}
          onChange={this.props.onChange}
          isCorrect={this._isCorrect(answer)}
          isEnabled={this._isEnabled()}
          id={this.props.id} />
      </li>
    );
  },

  _isChecked: function(answer) {
    return this.props.selectedAnswer === answer;
  },

  _isEnabled: function() {
    return this.props.correctAnswers.length === 0;
  },

  _isCorrect: function(answer) {
    return this.props.correctAnswers.indexOf(answer) > -1;
  }
});

module.exports = QuizOptions;



// WEBPACK FOOTER //
// ./src/advocate/stages/quiz/components/quiz_options.jsx